module.exports = __webpack_public_path__ + "static/28d-card-awards@2x-7a61f2a14baa0c89d92d36c49f939e38.png";